export interface CodeChangeEventDetail {
  value: string;
}
